import { commonMessages } from "components/common/commonMessages";
import { useIntl } from "components/_hooks/useIntl";
import { getVendorName } from "helpers/vendorHelper";
import { useEffect } from "react";
import { defineMessages } from "react-intl";

const messages = defineMessages({
  myAccount: {
    id: "document.title",
    defaultMessage: "MyAccount"
  }
});

export const useLocalisedDocumentTitle = pageTitleTranslationKey => {
  const intl = useIntl();

  useEffect(() => {
    if (pageTitleTranslationKey && commonMessages[pageTitleTranslationKey]) {
      const vendorName = getVendorName();
      const translationKey = commonMessages[pageTitleTranslationKey];
      document.title = `${intl.formatMessage(translationKey)} | ${vendorName}`;
    } else {
      document.title = intl.formatMessage(messages.myAccount);
    }
  }, []);
};
